export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./phone.vue?vue&type=template&id=5e93030b&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/shared/phone.vue?vue&type=template&id=5e93030b&
// module id = 25
// module chunks = 2 5